export default function PullRequest() {
  return (
    <div
      className="ion-icon-pull-request"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M128,64c-35.29,0-64,28.71-64,64c0,23.637,12.89,44.307,32,55.391v177.219C76.89,371.693,64,392.363,64,416
		c0,35.29,28.71,64,64,64s64-28.71,64-64c0-23.637-12.89-44.307-32-55.391V183.391c19.11-11.084,32-31.754,32-55.391
		C192,92.71,163.29,64,128,64z M128,448c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,448,128,448z M128,160
		c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,160,128,160z"/>
	<path d="M415,360.034V204.989c0-33.987-10.49-61.002-31.18-80.294c-22.111-20.618-54.314-30.388-95.82-29.106V32l-96,96l96,96v-64
		c26.5,0,42.67,2.642,52.175,11.504c7.183,6.698,10.825,17.964,10.825,33.485v156.196c-18.562,11.217-31,31.589-31,54.814
		c0,35.29,28.71,64,64,64s64-28.71,64-64C448,391.951,434.662,370.969,415,360.034z M384,448c-17.673,0-32-14.327-32-32
		s14.327-32,32-32s32,14.327,32,32S401.673,448,384,448z"/>
</g>
</svg>
`,
      }}
    />
  )
}
